export const APPLICATION_IS_READY_SUCCESS = 'AUDIT_MODELS/AUDIT_MODEL/APPLICATION_IS_READY_SUCCESS';
export const APPLICATION_IS_READY_FAILURE = 'AUDIT_MODELS/AUDIT_MODEL/APPLICATION_IS_READY_FAILURE';

export const FETCH = 'AUDIT_MODELS/AUDIT_MODEL/FETCH/REQUEST';
export const FETCH_SUCCESS = 'AUDIT_MODELS/AUDIT_MODEL/FETCH/SUCCESS';
export const FETCH_FAILURE = 'AUDIT_MODELS/AUDIT_MODEL/FETCH/FAILURE';

export const FETCH_FIELDS = 'AUDIT_MODELS/FIELDS/REQUEST';
export const FETCH_FIELDS_SUCCESS = 'AUDIT_MODELS/FIELDS/SUCCESS';
export const FETCH_FIELDS_FAILURE = 'AUDIT_MODELS/FIELDS/FAILURE';

export const FETCH_TRANSLATIONS = 'AUDIT_MODELS/TRANSLATIONS/REQUEST';
export const FETCH_TRANSLATIONS_SUCCESS = 'AUDIT_MODELS/TRANSLATIONS/SUCCESS';
export const FETCH_TRANSLATIONS_FAILURE = 'AUDIT_MODELS/TRANSLATIONS/FAILURE';

export const CREATE = 'AUDIT_MODELS/AUDIT_MODEL/CREATE_REQUEST';
export const CREATE_SUCCESS = 'AUDIT_MODELS/AUDIT_MODEL/CREATE_SUCCESS';
export const CREATE_FAILURE = 'AUDIT_MODELS/AUDIT_MODEL/CREATE_FAILURE';

export const UPDATE = 'AUDIT_MODELS/AUDIT_MODEL/UPDATE_REQUEST';
export const UPDATE_SUCCESS = 'AUDIT_MODELS/AUDIT_MODEL/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'AUDIT_MODELS/AUDIT_MODEL/UPDATE_FAILURE';

export const SET_SELECTED_LANGUAGE = 'AUDIT_MODELS/AUDIT_MODEL/SET_SELECTED_LANGUAGE';

export const DISPLAY_TARGET_MODAL = 'AUDIT_MODELS/MODAL/TARGET/DISPLAY';
export const HIDE_TARGET_MODAL = 'AUDIT_MODELS/MODAL/TARGET/HIDE';

export const DISPLAY_DUPLICATE_MODAL = 'AUDIT_MODELS/MODAL/DUPLICATE/DISPLAY';
export const HIDE_DUPLICATE_MODAL = 'AUDIT_MODELS/MODAL/DUPLICATE/HIDE';
export const SET_DUPLICATE_MODAL_DATA = 'AUDIT_MODELS/MODAL/DUPLICATE/SET_DATA';

export const UNPUBLISH = 'AUDIT_MODELS/UNPUBLISH/REQUEST';
export const DISPLAY_UNPUBLISH_MODAL = 'AUDIT_MODELS/MODAL/UNPUBLISH/DISPLAY';
export const HIDE_UNPUBLISH_MODAL = 'AUDIT_MODELS/MODAL/UNPUBLISH/HIDE';

export const DUPLICATE = 'AUDIT_MODELS/DUPLICATE_REQUEST';
export const DUPLICATE_SUCCESS = 'AUDIT_MODELS/DUPLICATE_SUCCESS';
export const DUPLICATE_FAILURE = 'AUDIT_MODELS/DUPLICATE_FAILURE';

export const INIT_AUDIT_MODELS_SELECT = 'AUDIT_MODELS/SELECT/INIT';
export const GET_AUDIT_MODELS_SELECT_FETCH = 'AUDIT_MODELS/SELECT/FETCH';
export const GET_AUDIT_MODELS_SELECT_FETCH_FAILURE = 'AUDIT_MODELS/SELECT/FETCH_FAILURE';
export const GET_AUDIT_MODELS_SELECT_FETCH_SUCCESS = 'AUDIT_MODELS/SELECT/FETCH_SUCCESS';
export const SET_AUDIT_MODELS_SELECT_FILTERS = 'AUDIT_MODELS/SELECT/FILTERS';

export const PATCH_AUDIT_MODEL_STATUS = 'AUDIT_MODEL/STATUS/PATCH_REQUEST';
export const PATCH_AUDIT_MODEL_STATUS_SUCCESS = 'AUDIT_MODEL/STATUS/PATCH_SUCCESS';
export const PATCH_AUDIT_MODEL_STATUS_FAILURE = 'AUDIT_MODEL/STATUS/PATCH_FAILURE';

export const FETCH_AUDIT_MODELS_MY = 'AUDIT_MODELS/MY_MODELS/FETCH';
export const FETCH_AUDIT_MODELS_MY_SUCCESS = 'AUDIT_MODELS/MY_MODELS/FETCH_SUCCESS';
export const FETCH_AUDIT_MODELS_MY_FAILURE = 'AUDIT_MODELS/MY_MODELS_FETCH_FAILURE';

export const FETCH_AUDIT_MODELS_AVAILABLE = 'AUDIT_MODELS/AVAILABLE/FETCH_REQUEST';
export const FETCH_AUDIT_MODELS_AVAILABLE_SUCCESS = 'AUDIT_MODELS/AVAILABLE/FETCH_SUCCESS';
export const FETCH_AUDIT_MODELS_AVAILABLE_FAILURE = 'AUDIT_MODELS/AVAILABLE/FETCH_FAILURE';

export const SELECT_AUDIT_MODEL = 'AUDIT_MODELS/DASHBOARD/SELECT_ONE';

export const START_SECTION_DND = 'AUDIT_MODEL/DETAILS/START_SECTION_DND';
export const END_SECTION_DND = 'AUDIT_MODEL/DETAILS/END_SECTION_DND';

export const DELETE_AUDIT_MODEL = 'AUDIT_MODEL/DELETE_REQUEST';
export const DELETE_AUDIT_MODEL_SUCCESS = 'AUDIT_MODEL/DELETE_SUCCESS';
export const DELETE_AUDIT_MODEL_FAILURE = 'AUDIT_MODEL/DELETE_FAILURE';

export const DEACTIVATE_AUDIT_MODEL = 'AUDIT_MODEL/DEACTIVATE/DELETE_REQUEST';
export const DEACTIVATE_AUDIT_MODEL_SUCCESS = 'AUDIT_MODEL/DEACTIVATE/DELETE_SUCCESS';
export const DEACTIVATE_AUDIT_MODEL_FAILURE = 'AUDIT_MODEL/DEACTIVATE/DELETE_FAILURE';

export const ACTIVATE_AUDIT_MODEL = 'AUDIT_MODEL/ACTIVATE/POST_REQUEST';
export const ACTIVATE_AUDIT_MODEL_SUCCESS = 'AUDIT_MODEL/ACTIVATE/POST_SUCCESS';
export const ACTIVATE_AUDIT_MODEL_FAILURE = 'AUDIT_MODEL/ACTIVATE/POST_FAILURE';
